import { useSelector } from 'react-redux';
import { StoreState } from '@bcp-nextgen-dx-touchpoint-framework/react-js';
import { AppState } from '../..';

export const useIsOperator = (): boolean => {
	return useSelector((state: StoreState<AppState>) => state.appState.tempDataState.isUnauthorizedUser || false);
};
